import '~/js/modules/stickyNav';
import Accomodations from '~/js/views/resorts/components/Accomodations';

import '~/js/views/resorts/includes/scroll-below';
// import '../includes/list-grid-viewer';

const internals = {
    filters: {
        roomCategories: ['1BS', 'ZSS']
    }
};

const reactAccomodations = document.querySelector('#rct-accomodations');

// $('a[href="#"]').on('click', e => {
//     e.preventDefault();
// });


ReactDOM.render(<Accomodations filters={internals.filters} />, reactAccomodations);
